export default () => {
    const intervalFormat = document.querySelector('#interval_format');

    const tag_to = document.querySelector(`#tag_to`);
    const tag_new = document.querySelector(`#tag_new`);
    const form_create_gitlab_report = document.querySelector(`#form_create_gitlab_report`);
    const updated_after = document.querySelector(`#updated_after`);
    const updated_before = document.querySelector(`#updated_before`);

    intervalFormat?.addEventListener("change", function (e) {

        const tab_tag = document.querySelector(`.js--tag_type`);
        const tab_branch = document.querySelector(`.js--branch_type`);

        if (e.target.checked) {
            tab_tag?.classList.remove('active');
            tab_branch?.classList.add('active');
        } else {
            tab_tag?.classList.add('active');
            tab_branch?.classList.remove('active');
        }
    });
    tag_to?.addEventListener("change", function (e) {
        const tag_value = e.target.value;
        if (tag_value) {
            tag_new.value = tag_value;
            tag_new.setAttribute('disabled', 'disabled');
        } else {
            tag_new.value = '';
        }
    });
    form_create_gitlab_report?.addEventListener("submit", function (e) {
        if (intervalFormat.checked) {
            checkRequired(e, updated_after);
            checkRequired(e, updated_before);
        } else {
            checkRequired(e, tag_new);
        }
    });

    function checkRequired(e, elem) {
        if (!elem.value) {
            elem.parentNode.classList.add('required');
            e.preventDefault();
        } else {
            elem.parentNode.classList.remove('required');
        }
    }
};
